import React, { PureComponent } from 'react'
import { withRouter } from 'react-router-dom'
import { omit, orderBy, omitBy, take, get } from 'lodash'
import { connect } from 'react-redux'
import AutoCompleteFilter from './AutoCompleteFilter'
import { getAttributeValues } from '../../selectors'
import {
  loadAttributeValuesWithCount,
  unloadAttributeValues,
} from '../../actions'
import {
  shouldShowGenereFilterByCategoryId,
  parseQsAttributes,
  makeParseQsAttributesMem,
  parseQsGenere,
  mergeQs,
} from '../../utils'

class AutoCompleteAttribute extends PureComponent {
  getCrossFilters = () => {
    let crossFilters = omit(this.props.attributesFilters, this.props.attribute)
    const { genereValue } = this.props
    if (typeof genereValue !== 'undefined') {
      crossFilters = { ...crossFilters, genere: genereValue }
    }
    return crossFilters
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.attribute !== nextProps.attribute ||
      this.props.categoryId !== nextProps.categoryId
    ) {
      this.autocomplete.clear()
    }
  }

  loadSuggestions = q => {
    this.props.loadAttributeValuesWithCount(
      this.props.attribute,
      this.props.categoryId,
      q,
      this.getCrossFilters(),
      true
    )
  }

  clearSuggestions = () => {
    this.props.unloadAttributeValues(this.props.attribute)
  }

  componentWillUnmount() {
    this.props.unloadAttributeValues(this.props.attribute)
  }

  updateQs = newValue => {
    const currentAttributes = parseQsAttributes(this.props.location)
    const attributi = omitBy(
      {
        ...currentAttributes,
        [this.props.attribute]: newValue,
      },
      v => v === ''
    )

    this.props.history.push(
      `${this.props.location.pathname}?${mergeQs(this.props.location, {
        attributi: JSON.stringify(attributi),
      })}`
    )
  }

  render() {
    const {
      fullWidth = false,
      label,
      onFocus,
      onBlur,
      openToTop = false,
      values,
    } = this.props
    return (
      <AutoCompleteFilter
        ref={ref => (this.autocomplete = ref)}
        {...omit(this.props, [
          'values',
          'loadAttributeValuesWithCount',
          'unloadAttributeValues',
        ])}
        onSuggestionSelected={this.updateQs}
        loadSuggestions={this.loadSuggestions}
        clearSuggestions={this.clearSuggestions}
        suggestions={values}
        onFocus={onFocus}
        onBlur={onBlur}
        fullWidth={fullWidth}
        openToTop={openToTop}
        label={label}
      />
    )
  }
}

const parseQsAttributesMem = makeParseQsAttributesMem()

const mapStateToProps = (state, ownProps) => {
  const getValues = getAttributeValues(ownProps.attribute)
  const attributesFilters = parseQsAttributesMem(ownProps.location)
  let genereValue
  if (shouldShowGenereFilterByCategoryId(ownProps.categoryId)) {
    genereValue = parseQsGenere(ownProps.location)
  }
  return {
    attributesFilters,
    genereValue,
    values: getValues(state),
    value: get(attributesFilters, ownProps.attribute, ''),
  }
}

export default withRouter(
  connect(mapStateToProps, {
    loadAttributeValuesWithCount,
    unloadAttributeValues,
  })(AutoCompleteAttribute)
)



// WEBPACK FOOTER //
// ./src/common/TopBar/AutoCompleteAttribute.js